<script setup>
import { useNavigationProgress } from '@/composables/useNavigationProgress';

// Thin top-of-viewport progress bar shown while a route navigation is in flight
// (mainly a cold page chunk still loading). State + timing live in the composable;
// this component is purely the visual. Mounted once, globally, from App.vue.
const { isActive, progress } = useNavigationProgress();
</script>

<template>
  <div
    class="nav-progress"
    :class="{ 'nav-progress--active': isActive }"
    aria-hidden="true"
  >
    <div
      class="nav-progress-bar"
      :style="{ transform: `scaleX(${progress})` }"
    />
  </div>
</template>

<style scoped>
.nav-progress {
  position: fixed;
  inset: 0 0 auto 0;
  height: 2px;
  z-index: 100000;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.nav-progress--active {
  opacity: 1;
}

.nav-progress-bar {
  height: 100%;
  width: 100%;
  transform: scaleX(0);
  transform-origin: left center;
  /* Theme-adaptive accent: deep purple on the light header, soft lavender on the dark
     header — a bit more contrast than the header background without being bright. */
  background: var(--wp-text-accent);
  transition: transform 0.2s ease;
}
</style>
